const timeline = document.getElementById('bldg-timeline');
  const wrapper = document.querySelector('.bldg-timeline__wrapper');
  const container = document.querySelector('.bldg-timeline__container');
  const track = document.querySelector('.bldg-timeline__track');
  const slides = document.querySelectorAll('.bldg-timeline__slide');
  const scroller = document.querySelector('.bldg-timeline__scroller');
  const counter = document.getElementById('timeline-counter');
  const totalSlides = slides.length;

  function setWidths() {
    const viewportWidth = document.documentElement.clientWidth;

    // Set the total track width
    scroller.style.width = `${viewportWidth * totalSlides}px`;

    // Set each slide's width
    slides.forEach(slide => {
      slide.style.width = `${viewportWidth}px`;
    });
  }

  setWidths(); // initial run
  window.addEventListener('resize', setWidths); // handle orientation change

  window.addEventListener('scroll', function() {
    const viewportWidth = document.documentElement.clientWidth;
    const scrollTop = window.scrollY;
    const offsetTop = timeline.offsetTop;
    const timelineHeight = timeline.offsetHeight;
    const viewportHeight = window.innerHeight;
    const scrollDistance = timelineHeight - viewportHeight;

    if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollDistance) {
      wrapper.style.position = 'fixed';
      wrapper.style.top = '0';
      wrapper.style.left = '0';
      wrapper.style.width = '100%';
      wrapper.style.height = '100vh';

      const progress = (scrollTop - offsetTop) / scrollDistance;
      const translateX = progress * (totalSlides - 1) * -viewportWidth;
      track.style.transform = `translateX(${translateX}px)`;

      const currentIndex = Math.round(progress * (totalSlides - 1));
      counter.textContent = currentIndex + 1;
    } else if (scrollTop > offsetTop + scrollDistance) {
      wrapper.style.position = 'absolute';
      wrapper.style.top = 'auto';
      wrapper.style.bottom = '0';
    } else {
      wrapper.style.position = 'relative';
      wrapper.style.top = '0';
    }
  });